import getDefaultFolderIdToLoad from './helpers/getDefaultFolderIdToLoad';
import selectFolder from './selectFolder';
import { isFolderInFavorites } from 'owa-favorites';
import { action } from 'satcheljs/lib/legacy';
export default action('selectDefaultFolder')(function selectDefaultFolder() {
    var defaultFolderIdToLoad = getDefaultFolderIdToLoad();
    var treeType = isFolderInFavorites(defaultFolderIdToLoad)
        ? 'favorites'
        : 'primaryFolderTree';
    selectFolder(defaultFolderIdToLoad, treeType, 'NonUserAction' /* ActionSource */);
});
//# sourceMappingURL=selectDefaultFolder.js.map